import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineDiamondIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m20 10.35-5.78-7.41a3.0596 3.0596 0 0 0-3.4628-.6708A3.059 3.059 0 0 0 9.75 3L4 10.35A3.0497 3.0497 0 0 0 3.51 12 3.0902 3.0902 0 0 0 4 13.58l.06.07 5.74 7.41A3.0013 3.0013 0 0 0 12 22a3.0607 3.0607 0 0 0 2.26-1L20 13.65a3.0002 3.0002 0 0 0-.06-3.3H20Zm-1.57 2.14-5.67 7.22a1.1102 1.1102 0 0 1-1.42.07l-5.69-7.31a1.0002 1.0002 0 0 1-.14-.47 1.1096 1.1096 0 0 1 .1-.45l5.67-7.22a1.1102 1.1102 0 0 1 1.42-.07l5.63 7.28a.9996.9996 0 0 1 .16.54 1.1087 1.1087 0 0 1-.1.41h.04Z"/>
  </SvgIcon>
}

export default LineDiamondIcon
